import React, { useState } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./CategoryList.css";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function Categorylist() {
  const categories = useSelector((state) => state.categories || []);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const matches = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const navigate = useNavigate()

  const handleNaviate=(sub)=>{
    releasebody(
      
    )
    navigate(`/products/${sub.id}`)
  }
   
  const CategoryItem = styled.div`
  
  padding:.4rem .5rem;

  &:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }
  
  
  `

  const SubCategoryList = styled.div`
  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out, visibility 0.7s ease-in-out;
  opacity: ${hoveredCategory ? 1 : 0};
  transform: ${hoveredCategory ? "translateY(0)" : "translateY(-10px)"};
  visibility: ${hoveredCategory ? "visible" : "hidden"};

  width:105vw;
  height:411px;
  left:7rem;
  position:fixed;
  z-index:22;
  top:7.1rem;
  display: grid;

  gap: 0.5rem;
  overflow-y: auto;
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  background-color:#fff;
  flex-direction:column;
 padding:2rem 5rem;



padding-right:auto;
align-content:flex-start;


.item55:nth-child(5n+1) {
  break-before: column;
  break-inside: avoid;
}

grid-auto-rows: auto;
column-count: 2;
column-gap: 1rem;

  .item55 {
     color: #222;
     
     display: flex;
     align-items: flex-start;
     flex-direction: column;
     text-align: left;
     justify-content: flex-start;
     box-sizing: border-box;
     padding: 2px;
     text-align: left;
     width: 211px !important;
     break-inside: avoid-column;
     padding-left:1rem;
  }

  .item55 p {
color: #222;
margin: 0;
}
    .item55:hover{
     
     background-color: unset;
     }


     .subcatlayer3{
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: flex-start;
     text-align: left;
     font-size: 0.8rem;
     
     width: 100%;
     }
      .subcatlayer3item{
 padding: 0.19rem 0;
 color: #888;
}
 .subcatlayer3item:hover {

    color: #555;
  }

  @media (max-width: 1090px) {
   .categorylist__cont{
     display: flex;
     }
}
  @media (max-width: 600px) {
  
    
    padding: 1rem;
    column-count: 1;
  }
    display: flex;
    flex-wrap: wrap;
   
   
   .item55:nth-child(5n+1) {
      break-before: column;
      break-inside: avoid;
    }

  
  
  `

  const fixbody = (category) => {
    document.body.style.overflow = "hidden";
    setHoveredCategory(category);

 
  };


  const releasebody = () => {
    document.body.style.overflow = "unset";
    setHoveredCategory(null);
  };


  const CategoryMain = styled.div`
  
  @media (max-width: 1080px) {
 
    display: none;

}
  `

  return (
    <CategoryMain className="categorylist__cont" style={{backgroundColor:'#fff',justifyContent:'flex-start',paddingLeft:'2rem',borderTop:'1px solid #f0f0f0'}}>
      {categories.map((category, index) => (
        <div
          key={index}
          className="categoryitemm"
          onMouseEnter={() => {
            fixbody(category)
                               
          }}
          onMouseLeave={() => {releasebody()}}
        style={{color:'#222',fontSize:'.9rem',backgroundColor:'unset',padding:1}}  
        >
        <CategoryItem>{category.name}</CategoryItem>

         
          {hoveredCategory === category && category.children && (
            <SubCategoryList
              className="subcategorylist"
              onMouseEnter={() => setHoveredCategory(category)} 
              onMouseLeave={() => setHoveredCategory(null)} 

             
            >
              {category.children.map((sub, subIndex) => (
                <div key={subIndex} className="subcategoryit item55" >
                 <p  onClick={()=>{handleNaviate(sub)}}  >{sub.name}</p>

                  <div className="subcatlayer3">
                    {sub.children && sub.children.map((child, childIndex) => (
                      <div key={childIndex} className="subcatlayer3item" onClick={()=>{handleNaviate(child)}} >
                        {child.name}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </SubCategoryList>
          )}
        </div>
      ))}
    </CategoryMain>
  );
}
